<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <ClientNav v-if="$route.query.clientNav !== 'false'"/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form
                            ref="form"
                            lazy-validation>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            v-model="newRegionalCenter"
                                            label="Regional Center"
                                            :items="regionalCenters"
                                            :rules='requiredField'
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            v-model="newType"
                                            label="Incident Category"
                                            :items="category"
                                            :rules='requiredField'
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="DS I.R Number"
                                            v-model="newDSINumber"
                                            hint="REGIONAL CENTER USE ONLY"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4">
                                        <v-text-field
                                            label="DS S.O.R Number"
                                            v-model="newDSORNumber"
                                            hint="REGIONAL CENTER USE ONLY"

                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4">
                                        <v-menu
                                            ref="calendarMenu"
                                            v-model="calendarMenu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newDateReceived"
                                                    label="Date Report Received"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :rules='requiredField'
                                                    hint="REGIONAL CENTER USE ONLY"

                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newDateReceived"
                                                no-title
                                                scrollable
                                                :rules='requiredField'

                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="calendarMenu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.calendarMenu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            label="Select a Program"
                                            v-model="newProgram"
                                            :items="programs"
                                            item-value="Name"
                                            item-text="Name"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="6">
                                        <v-select
                                            label="Program Type"
                                            v-model="newProgramType"
                                            :items="programType"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4">
                                        <v-select
                                            label="Incident Type"
                                            v-model="newIncidentType"
                                            :items="IRTypes"
                                        ></v-select>
                                    </v-col>


                                    <v-col cols="12" sm="12" md="4">
                                        <v-menu
                                            id="incident-date-picker"
                                            ref="calendar2Menu"
                                            v-model="calendar2Menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newIncidentDate"
                                                    label="Incident Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :rules='requiredField'
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                id="incident-date-picker"
                                                v-model="newIncidentDate"
                                                no-title
                                                scrollable
                                                :rules='requiredField'

                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="calendar2Menu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    id="incident-date-ok"
                                                    text
                                                    color="primary"
                                                    @click="$refs.calendar2Menu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12" md="4">
                                        <v-menu
                                            id="incident-date-time-discovery"
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    id="incident-time-discovery"
                                                    v-model="newIncidentTime"
                                                    label="Time of Incident or Discovery"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>


                                    <v-col cols="12" sm="12">
                                        <v-text-field
                                            label="Responsible Provider/Agency"
                                            v-model="newProvider"

                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-menu
                                            ref="calendar3Menu"
                                            v-model="calendar3Menu"
                                            :close-on-content-click="false"
                                            :return-value.sync="date"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="newReportDate"
                                                    label="Report Date"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    :rules='requiredField'
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="newReportDate"
                                                no-title
                                                scrollable
                                                :rules='requiredField'

                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="calendar3Menu = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="$refs.calendar3Menu.save(date)"
                                                >
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <v-text-field
                                            v-model="newServiceCoordinator"
                                            label="Service Coordinator"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"
                                    >People Involved/Witness Involved
                                    </v-col>


                                    <v-col cols="12">
                                        <v-card>
                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-text-field
                                                    v-model="newPrimaryPerson"
                                                    label="Primary Person"
                                                    :rules='requiredField'
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-select
                                                    v-model="newInvolvedWitness"
                                                    label="InvolvedWitness"
                                                    :rules='requiredField'
                                                    :items="involved"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newPersonServed"
                                                    label="Person Served"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newStaff"
                                                    label="Staff"
                                                ></v-checkbox>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-btn v-model="newPerson2" @click="newPerson2=true"
                                                       small>Add Person
                                                </v-btn>
                                            </v-col>

                                        </v-card>
                                    </v-col>

                                    <v-col cols="12" v-if="newPerson2">
                                        <v-card>

                                            <v-col class="d-flex mt-10" cols="12" sm="12">
                                                <v-text-field
                                                    v-model="newPersonName2"
                                                    label="Name"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-select
                                                    v-model="newInvolvedWitness2"
                                                    label="Involved/Witness"
                                                    :items="involved"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newPersonServed2"
                                                    label="Person Served"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newStaff2"
                                                    label="Staff"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newOther2"
                                                    label="Other"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-btn v-model="newPerson3" @click="newPerson3=true"
                                                       small>Add Person
                                                </v-btn>
                                            </v-col>

                                        </v-card>
                                    </v-col>


                                    <v-col cols="12" v-if="newPerson3">
                                        <v-card>
                                            <v-col class="d-flex mt-10" cols="12" sm="12">
                                                <v-text-field
                                                    v-model="newPersonName3"
                                                    label="Name"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex mt-10" cols="12" sm="12">
                                                <v-select
                                                    v-model="newInvolvedWitness3"
                                                    label="Involved/Witness"
                                                    :items="involved"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newPersonServed3"
                                                    label="Person Served"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newStaff3"
                                                    label="Staff"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newOther3"
                                                    label="Other"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-btn v-model="newPerson4" @click="newPerson4=true"
                                                       small>Add Person
                                                </v-btn>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col cols="12" v-if="newPerson4">
                                        <v-card>
                                            <v-col class="d-flex mt-10" cols="12" sm="12">
                                                <v-text-field
                                                    v-model="newPersonName4"
                                                    label="Name"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-select
                                                    v-model="newInvolvedWitness4"
                                                    label="Involved/Witness"
                                                    :items="involved"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newPersonServed4"
                                                    label="Person Served"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newStaff4"
                                                    label="Staff"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newOther4"
                                                    label="Other"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-btn v-model="newPerson5" @click="newPerson5=true"
                                                       small>Add Person
                                                </v-btn>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col cols="12" v-if="newPerson5">
                                        <v-card>
                                            <v-col class="d-flex mt-10" cols="12" sm="12">
                                                <v-text-field
                                                    v-model="newPersonName5"
                                                    label="Name"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-select
                                                    v-model="newInvolvedWitness5"
                                                    label="Involved/Witness"
                                                    :items="involved"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newPersonServed5"
                                                    label="Person Served"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newStaff5"
                                                    label="Staff"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newOther5"
                                                    label="Other"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-btn v-model="newPerson6" @click="newPerson6=true"
                                                       small>Add Person
                                                </v-btn>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col cols="12" v-if="newPerson6">
                                        <v-card>
                                            <v-col class="d-flex mt-10" cols="12" sm="12">
                                                <v-text-field
                                                    v-model="newPersonName6"
                                                    label="Name"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col class="d-flex mt-10" cols="12" sm="12">
                                                <v-select
                                                    v-model="newInvolvedWitness6"
                                                    label="Involved/Witness"
                                                    :items="involved"
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newPersonServed6"
                                                    label="Person Served"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newStaff6"
                                                    label="Staff"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-checkbox
                                                    v-model="newOther6"
                                                    label="Other"
                                                ></v-checkbox>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        For Primary Person Only
                                    </v-col>


                                    <v-col cols="12">
                                        <v-card>
                                            <h4 class="ma-4 red--text">Type of services person is
                                                receiving (check all that apply)</h4>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-select
                                                    v-model="newLiving"
                                                    label="Living"
                                                    :items="living"
                                                    multiple
                                                ></v-select>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-select
                                                    v-model="newJDT"
                                                    label="JDT (Jobs & Day Training)"
                                                    :items="jdt"
                                                ></v-select>
                                            </v-col>


                                            <v-col cols="12" v-if="newJDT === 'Other'">
                                                <v-textarea
                                                    outlined
                                                    label="Describe"
                                                    v-model="newJDTOther"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col class="d-flex" cols="12" sm="12">
                                                <v-textarea
                                                    v-model="newEventDescription"
                                                    label="Description of Event"
                                                    hint="Be Complete and Concise"
                                                    outlined
                                                ></v-textarea>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Incident Recording and information
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <span>Missing Person Report?</span>
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newMissingPersonReport"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newMissingPersonReport"
                                        ></v-checkbox>
                                    </v-col>


                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Injury
                                    </v-col>

                                    <v-col cols="12">
                                        <span>Injury?</span>
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newInjury"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newInjury"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="newInjury === 'Yes'">
                                        <v-card>
                                            <v-col cols="12">
                                                <v-select
                                                    label="Type of Injury"
                                                    v-model="newInjuryType"
                                                    :items="injuryTypes"
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    id="new-injury-additional-detail"
                                                    outlined
                                                    label="Additional Detail"
                                                    v-model="newInjuryDetails"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-select
                                                    label="Cause of Injury"
                                                    v-model="newInjuryCause"
                                                    :items="injuryCauses"
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    id="injury-cause-additional-detail"
                                                    outlined
                                                    label="Additional Detail"
                                                    v-model="newInjuryDetails2"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-select
                                                    label="Who Caused the Injury"
                                                    v-model="newInjuryPerson"
                                                    :items="injuryPerson"
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    id="caused-additional-detail"
                                                    outlined
                                                    label="Additional Detail"
                                                    v-model="newInjuryDetails3"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <span>Was a nurse notified?</span>
                                                <v-checkbox
                                                    label="Yes"
                                                    value="Yes"
                                                    v-model="newNurse"
                                                ></v-checkbox>
                                                <v-checkbox
                                                    label="No"
                                                    value="No"
                                                    v-model="newNurse"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <span>Was medical treatment notified?</span>
                                                <v-checkbox
                                                    label="Yes"
                                                    value="Yes"
                                                    v-model="newMedicalTreatment"
                                                ></v-checkbox>
                                                <v-checkbox
                                                    label="No"
                                                    value="No"
                                                    v-model="newMedicalTreatment"
                                                ></v-checkbox>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Unplanned Hospitalization
                                    </v-col>


                                    <v-col cols="12">
                                        <span>Unplanned Hospitalization?</span>

                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newUnplanned"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newUnplanned"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="newUnplanned === 'Yes'">
                                        <v-card>
                                            <v-col cols="12">
                                                <v-select
                                                    id="hospital-types"
                                                    label="Check all that apply"
                                                    v-model="newHospitalType"
                                                    :items="hospitalTypes"
                                                    multiple
                                                ></v-select>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Aggression or Inappropriate Interactions between People
                                        Receiving Services
                                    </v-col>


                                    <v-col cols="12">
                                        <span>Aggression or Inappropriate Interactions between People Receiving Services?</span>
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newAggression"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newAggression"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="newAggression === 'Yes'">
                                        <v-select
                                            id="aggression-types"
                                            label="Check all that apply"
                                            v-model="newAggressionType"
                                            :items="aggressionTypes"
                                            multiple
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Is There a Concern of Abuse/Neglect/Exploitation or Improper
                                        Treatment
                                    </v-col>


                                    <v-col cols="12">
                                        <span>Is There a Concern of Abuse/Neglect/Exploitation or Improper Treatment?</span>
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newAbuseNeglect"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newAbuseNeglect"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="newAbuseNeglect === 'Yes'">
                                        <v-textarea
                                            id="abuse-description"
                                            outlined
                                            label="Please explain in detail"
                                            v-model="newAbuseDescription"
                                        ></v-textarea>
                                    </v-col>


                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Vehicle Accident
                                    </v-col>


                                    <v-col cols="12">
                                        <span>Vehicle Accident?</span>
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newVehicleAccident"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newVehicleAccident"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="newVehicleAccident === 'Yes'">
                                        <v-select
                                            id="vehicle-types"
                                            label="Check all that apply"
                                            v-model="newVehicleType"
                                            :items="vehicleTypes"
                                            multiple
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Medical
                                    </v-col>


                                    <v-col cols="12">
                                        <span id="medical">Medical?</span>
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newMedical"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newMedical"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="newMedical === 'Yes'">
                                        <v-card>
                                            <v-col cols="12">
                                                <v-select
                                                    id="medical-type"
                                                    label="Select One"
                                                    v-model="newMedicalType"
                                                    :items="medicalTypes"
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    id="medical-details"
                                                    label="Explain from details above"
                                                    v-model="newMedicalDetails"
                                                    outlined
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-checkbox
                                                    label="Med Error"
                                                    v-model="newMedError"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-select
                                                    id="medical-error-types"
                                                    label="Select all that apply"
                                                    v-model="newMedErrorType"
                                                    :items="medErrorTypes"
                                                    multiple
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    id="other-medical-error-type"
                                                    outlined
                                                    label="Specify"
                                                    v-model="newMedOther"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="4">
                                                <v-menu
                                                    ref="calendar4Menu"
                                                    v-model="calendar4Menu"
                                                    :close-on-content-click="false"
                                                    :return-value.sync="date"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="newErrorDate"
                                                            label="Date/Time Error Occurred"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :rules='requiredField'
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="newErrorDate"
                                                        no-title
                                                        scrollable
                                                        :rules='requiredField'

                                                    >
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            text
                                                            color="primary"
                                                            @click="calendar4Menu = false"
                                                        >
                                                            Cancel
                                                        </v-btn>
                                                        <v-btn
                                                            text
                                                            color="primary"
                                                            @click="$refs.calendar4Menu.save(date)"
                                                        >
                                                            OK
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="4">
                                                <v-menu
                                                    ref="calendar5Menu"
                                                    v-model="calendar5Menu"
                                                    :close-on-content-click="false"
                                                    :return-value.sync="date"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="newErrorTime"
                                                            label="Date/Time Error Discovered"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :rules='requiredField'
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="newErrorTime"
                                                        no-title
                                                        scrollable
                                                        :rules='requiredField'

                                                    >
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            text
                                                            color="primary"
                                                            @click="calendar5Menu = false"
                                                        >
                                                            Cancel
                                                        </v-btn>
                                                        <v-btn
                                                            text
                                                            color="primary"
                                                            @click="$refs.calendar5Menu.save(date)"
                                                        >
                                                            OK
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-checkbox
                                                    label="Physician Notified"
                                                    v-model="newPhysicianNotified"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    label="Effects of Medication Error"
                                                    v-model="newEffects"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    outlined
                                                    label="Details/Nursing Comments"
                                                    v-model="newNursingDetails"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    label="Staff Name"
                                                    v-model="newStaffName"
                                                    :rules='requiredField'
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    label="Signature"
                                                    v-model="newSignatureDate"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    label="Date and Time"
                                                    v-model="newMedDate"
                                                ></v-text-field>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Possible Unlawful Behavior/Police Involvement
                                    </v-col>

                                    <v-col cols="12">
                                        <span
                                            id="police-involvement">Possible Unlawful Behavior/Police Involvement</span>
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newPolice"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newPolice"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="newPolice === 'Yes'">
                                        <v-card>
                                            <v-col cols="12">
                                                <v-select
                                                    label="Select all that apply"
                                                    v-model="newBehavior"
                                                    :items="behaviors"
                                                    multiple
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    outlined
                                                    v-model="newPropertyDamage"
                                                    label="Describe Property Damage"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    outlined
                                                    v-model="newDamageOther"
                                                    label="Other Specify"
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="12">
                                                <span id="police-notified">Were Police Involved/Notified?</span>
                                                <v-checkbox
                                                    label="Yes"
                                                    value="Yes"
                                                    v-model="newPoliceInvolved"
                                                ></v-checkbox>
                                                <v-checkbox
                                                    label="No"
                                                    value="No"
                                                    v-model="newPoliceInvolved"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <span>Was the person Arrested?</span>
                                                <v-checkbox
                                                    label="Yes"
                                                    value="Yes"
                                                    v-model="newArrested"
                                                ></v-checkbox>
                                                <v-checkbox
                                                    label="No"
                                                    value="No"
                                                    v-model="newArrested"
                                                ></v-checkbox>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-select
                                                    label="Victim"
                                                    v-model="newVictim"
                                                    :items="victims"
                                                ></v-select>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-textarea
                                                    outlined
                                                    label="Other (specify)"
                                                    v-model="newVictimOther"
                                                ></v-textarea>
                                            </v-col>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Death
                                    </v-col>

                                    <v-col cols="12">
                                        <span>Death?</span>
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="newDeath"
                                        ></v-checkbox>
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="newDeath"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" v-if="newDeath === 'Yes'">
                                        <v-select
                                            label="Cause of Death"
                                            v-model="newDeathType"
                                            :items="deaths"
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Other
                                    </v-col>


                                    <v-col cols="12">
                                        <v-textarea
                                            label="Other (describe)"
                                            v-model="newOtherDescribe"
                                            outlined
                                        ></v-textarea>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Notification/Review
                                    </v-col>

                                    <h4 class="ma-4 red--text">DS Agency must be notified by
                                        telephone immediately for all incidents involving potential
                                        abuse, neglect, or serious injury and the incident report
                                        submitted with in one working day.</h4>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="ASDS (Note who you spoke with)"
                                            v-model="newASDS"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="Family (Note who you spoke with)"
                                            v-model="newFamily"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            id="guardian"
                                            label="Guardian (Note who you spoke with)"
                                            v-model="newGuardian"
                                            :rules='requiredField'
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            id="service-coordinator"
                                            label="Service Coordinator (Note who you spoke with)"
                                            v-model="newServiceCoordinatorName"
                                            :rules='requiredField'
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="Police/911 (Note who you spoke with)"
                                            v-model="newPolice911"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="HCQC (Note who you spoke with)"
                                            v-model="newHealthCareQuality"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="Aging Services (Note who you spoke with)"
                                            v-model="newAgingServices"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="CPS (Note who you spoke with)"
                                            v-model="newCPS"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="Coroner (Note who you spoke with)"
                                            v-model="newCoroner"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            id="shift-supervisor"
                                            label="Shift Supervisor/Supervisor (Note who you spoke with)"
                                            v-model="newShiftSupervisor"
                                            :rules='requiredField'
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="Nurse (Note who you spoke with)"
                                            v-model="newNurseName"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            id="agency-administrator"
                                            label="Agency Admin (Note who you spoke with)"
                                            v-model="newAgencyAdmin"
                                            :rules='requiredField'
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                            label="Other (Describe ie. JDT))"
                                            v-model="newAgencyOther"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                            id="actions-taken"
                                            label="Actions taken to protect and reduce Risk"
                                            v-model="newActionsTaken"
                                            :items="actions"
                                            :rules='requiredField'
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="background-color: #2b3990; border-radius: 10px"

                                    >
                                        Signature and Title
                                    </v-col>

                                    <h4 class="ma-4 red--text">
                                        Signature and Title of the person completing this Incident
                                        Report
                                    </h4>

                                    <v-col cols="12">
                                        <v-card>
                                            <v-col cols="12">
                                                <v-text-field
                                                    id="reporters-name"
                                                    label="Reporters Name"
                                                    v-model="newReportersName"
                                                    :rules='requiredField'
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    id="reporters-signature"
                                                    label="Reporters Signature (Click to sign)"
                                                    v-model="newReportersSignature"
                                                    :rules='requiredField'
                                                    :readonly="newReportersSignature ? true : false"
                                                    @click="addReportersSignature()"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    id="reporters-title"
                                                    label="Reporters Title"
                                                    v-model="newReportersTitle"
                                                    :rules='requiredField'
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="4">
                                                <v-menu
                                                    id="reporters-date"
                                                    ref="calendar6Menu"
                                                    v-model="calendar6Menu"
                                                    :close-on-content-click="false"
                                                    :return-value.sync="date"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            id="reporters-date-field"
                                                            v-model="newReportersDate"
                                                            label="Reporters Date"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :rules='requiredField'
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        id="reporters-date-field"
                                                        v-model="newReportersDate"
                                                        no-title
                                                        scrollable
                                                        :rules='requiredField'

                                                    >
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            text
                                                            color="primary"
                                                            @click="calendar6Menu = false"
                                                        >
                                                            Cancel
                                                        </v-btn>
                                                        <v-btn
                                                            text
                                                            color="primary"
                                                            @click="$refs.calendar6Menu.save(date)"
                                                        >
                                                            OK
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-card>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-card>
                                            <v-col cols="12">
                                                <v-text-field
                                                    label="Supervisor Signature"
                                                    v-model="newSupervisorSignature"
                                                    :readonly="newSupervisorSignature ? true : false"
                                                    @click="addSupervisorSignature()"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12">
                                                <v-text-field
                                                    label="Supervisor Title"
                                                    v-model="newSupervisorTitle"
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="12" sm="12" md="4">
                                                <v-menu
                                                    ref="calendar7Menu"
                                                    v-model="calendar7Menu"
                                                    :close-on-content-click="false"
                                                    :return-value.sync="date"
                                                    transition="scale-transition"
                                                    offset-y
                                                    min-width="auto"
                                                >
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field
                                                            v-model="newSupervisorDate"
                                                            label="Date"
                                                            prepend-icon="mdi-calendar"
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        v-model="newSupervisorDate"
                                                        no-title
                                                        scrollable

                                                    >
                                                        <v-spacer></v-spacer>
                                                        <v-btn
                                                            text
                                                            color="primary"
                                                            @click="calendar7Menu = false"
                                                        >
                                                            Cancel
                                                        </v-btn>
                                                        <v-btn
                                                            text
                                                            color="primary"
                                                            @click="$refs.calendar7Menu.save(date)"
                                                        >
                                                            OK
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                        </v-card>
                                    </v-col>


                                    <v-col cols="12">
                                        <v-checkbox
                                            label="Guardian Notified?"
                                            v-model="newGuardianNotified"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4" v-if="newGuardianNotified">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="newGuardianDate"
                                                    label="Date and Time"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-checkbox
                                            label="Service Coordinator Notified?"
                                            v-model="newSCNotified"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4" v-if="newSCNotified">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="newSCDate"
                                                    label="Date and Time"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-checkbox
                                            label="Compliance Submitted to the State?"
                                            v-model="newCompliance"
                                            value="Yes"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="4" v-if="newCompliance">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="newComplianceDate"
                                                    label="Date and Time"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>

                                    </v-col>

                                    <v-col cols="12" sm="12" md="4" v-if="newCompliance">
                                        <v-text-field
                                            label="WellSky IR Number"
                                            v-model="newWellSkyIR"
                                            :rules='requiredField'
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <h3>DSPD/OL Notification Submitted</h3>

                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="12">
                                        <h3>DSPD clients need to be uploaded to UPI and DCFS clients
                                            need to be uploaded to Office of Licensing (OL).
                                        </h3>

                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-radio-group v-model="newNotificationSubmitted">
                                            <v-radio
                                                label="Yes"
                                                value="Yes"
                                            ></v-radio>
                                            <v-radio
                                                label="No"
                                                value="No"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>

                                    <v-col cols="12" sm="12"
                                           v-if="newNotificationSubmitted === 'Yes'">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="reportSubmittedDate"
                                                    label="Date and Time Submitted"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>

                                    <v-col class="d-flex" cols="12" sm="6">
                                        <h3>DSPD/OL Report Submitted</h3>
                                    </v-col>

                                    <v-col cols="12" sm="12">
                                        <v-radio-group v-model="newReportSubmitted">
                                            <v-radio
                                                label="Yes"
                                                value="Yes"
                                            ></v-radio>
                                            <v-radio
                                                label="No"
                                                value="No"
                                            ></v-radio>
                                        </v-radio-group>
                                    </v-col>

                                    <v-col cols="12" sm="12" v-if="newReportSubmitted === 'Yes'">
                                        <v-menu
                                            offset-y
                                            min-width="290px"
                                            max-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-datetime-picker
                                                    v-model="newOLReportDate"
                                                    label="Date and Time Submitted"
                                                    prepend-icon="events"
                                                    v-on="on"
                                                ></v-datetime-picker>
                                            </template>
                                        </v-menu>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        class="white--text text-uppercase text-center"
                                        style="Uploabackground-color: #2b3990; border-radius: 10px"
                                    >Document
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-file-input
                                            multiple
                                            show-size
                                            class="pa-2"
                                            label="Upload a Document"
                                            :placeholder="joinDocument()"
                                            v-model="newDocument"
                                            filled
                                            @change="fileSelected"
                                        ></v-file-input>
                                        <div>
                                            <div v-if="selectedIncidentReport"
                                                 style="flex-wrap: wrap">
                                                <div
                                                    v-for="(document, index) in selectedIncidentReport.Documents"
                                                    :key="index">
                                                    <template
                                                        v-if="getFileType(document) === 'pdf'">
                                                        <LoadPDF :pdfFile="document"
                                                                 :pdfName="document"/>
                                                    </template>
                                                    <template
                                                        v-else-if="['jpg', 'jpeg', 'png'].includes(getFileType(document))">
                                                        <img :src="document" alt="" width="320"
                                                             height="240">
                                                    </template>
                                                    <template
                                                        v-else-if="['doc', 'docx'].includes(getFileType(document))">
                                                        <VueDocPreview :value="document"
                                                                       :type="'office'"
                                                                       width="500"/>
                                                    </template>
                                                    <template v-else>
                                                        <div>Loading...</div>
                                                    </template>
                                                    <v-icon @click="removeImage(index)"
                                                            title="Delete Document">mdi-delete
                                                    </v-icon>
                                                    <v-icon @click="downloadDocument(document)"
                                                            title="Download Document">mdi-download
                                                    </v-icon>
                                                </div>
                                            </div>
                                            <div v-else>
                                                Loading...
                                            </div>
                                        </div>

                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-checkbox
                                            label="Staff Signature"
                                            @click="addStaffSignature()"
                                            v-model="staffSignature"
                                            :rules='requiredField'
                                        ></v-checkbox>

                                    </v-col>

                                    <v-col cols="12" sm="12" v-if="staffSignature">
                                        <v-text-field
                                            v-model="newStaffSignature"
                                            label="Signature of Person Initiating Report"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrint()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!newIncident"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn class="white--text" color="#259647" @click="addIncident()" v-if="newIncident">Save
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="updateIncident()" v-if="!newIncident">Update
                        </v-btn
                        >
                        <v-btn color="blue darken-1" text @click="clearFieldsAndBack">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../../components/ClientNav'
import Foot from '../../../components/Footer'
import renameFileHelper from '../../../mixins/renameFileHelper'
import Swal from 'sweetalert2'
import AppUtil from "../../../../utils/app.util";
import moment from "moment/moment";
import LoadPDF from "@/views/client/MedVisit/loadPDF.vue";
import VueDocPreview from 'vue-doc-preview'
import PrintUtil from "../../../../utils/print-util";


const url = require("../../../client_config/config").url;
const NevadaIncidentService = require('../../../service/nevada-incident.service');

export default {
    mixins: [renameFileHelper],
    components: {
        LoadPDF,
        ClientNav,
        Foot,
        VueDocPreview

    },
    data() {
        return {
            headers: [
                {
                    text: 'Incident Category',
                    align: 'start',
                    sortable: true,
                    value: 'Type',
                },
                {text: "Incident Date", value: "IncidentDate"},
                {text: "Program Type", value: "ProgramType"},
                {text: "Incident Type", value: "IncidentType"},
                {text: "Reporters Signature", value: "ReportersSignature"},
                {text: "Submitted to State", value: "Compliance"},

                {text: "Actions", value: "actions", sortable: false},
            ],
            newIncident: false,
            msg: false,
            hospital: false,
            lawEnforcement: false,
            medicalCare: false,
            otherHospital: false,
            otherMedical: false,
            otherLaw: false,
            search: "",
            text: "",
            nevadaIncidents: [],
            units: [],
            users: [],
            staff: localStorage.getItem("Name"),
            codes: [],
            tempData: [],
            clientID: this.$route.params.clientID,
            id: this.$route.params.id,
            userID: localStorage.getItem("userID"),
            unitID: localStorage.getItem('unitID'),
            token: localStorage.getItem('token'),
            involved: ["Involved", "Witness"],
            programType: ["Day Program", "Residential"],
            regionalCenters: ["Desert Regional Center", "Rural Regional Center", "Sierra Regional Center"],
            category: ["Behavioral", "Medical", "Hospital", "Injury", "Allegations", "Property Damage"],
            type: ["Abuse/Neglect/Exploitation", "Aspiration/Choking", "Behavior Intervention", "Compromised Environment", "Drug/Alcohol",
                "Fatality", "Hospital", "Injury", "Medication Errors", "Missing Person", "Property Destruction",
                "Seizure", "Suicide Attempt/Threat", "Theft", "Other (Describe)"],
            location: ["Community", "Day Program", "Home", "Place of Employment", "Relative's Home", "School",
                "Vehicle", "Other"],
            living: ["Supported Living Arrangement (SLA)", "Intensive SLA", "Family Support Arrangement",
                "Host Home", "Respite", "ICF State", "ICF Private"],
            jdt: ["JDT", "Enclave", "Job", "Service Coordination Only", "Other"],
            IRTypes: ["Person Served", "Other Person", "Other Incident (eg. fire, disaster)"],
            injuryTypes: ["Abrasion or Cut", "Bruise", "Bite", "Bum", "Head Impact",
                "Choking", "Fracture or Sprain", "Puncture", "Swelling or Edema", "Pain (no visible injury)",
                "Poison", "Other"],
            injuryCauses: ["Medication (Complete other medical section)", "Seizure", "Assault", "Fall",
                "Equipment", "Medical procedure", "Vehicle Accident (complete that section)", "Self-inflicted", "Unknown Origin", "Other"],
            injuryPerson: ["Self - (SIB)", "Self = accident", "Other person Served", "Family Member", "Staff Member", "Unknown", "Other"],
            roles: ["Family Guardian", "Provider Staff", "Unknown", "Other Client", "Support Coordinator", "Other (describe)"],
            involvement: ["Direct Involvement", "Perpetrator", "Perpetrator and Victim", "Support Coordinator", "Victim", "Witness Only", "Other"],
            organization: ["911", "APS", "Behaviorist", "CPS", "Dental", "Guardian", "Hospital", "Law Enforcement", "Medical Clinic", "Natural Supports",
                "Parent", "Pharmacy", "Physician Clinic", "Poison Control", "Primary Care", "Provider Staff", "Therapist", "Urgent Care", "Other (Describe)"],
            incidentCategory: ["Abuse/Neglect/Exploitation", "Aspiration/Choking", "Behavior Intervention", "Compromised Environment", "Drug/Alcohol", "Fatality",
                "Hospital", "Injury", "Medication Errors", "Missing Person", "Physical Aggression", "Property Destruction", "Seizure", "Suicide Attempt/Threat", "Theft", "Other (describe)"],
            hospitalTypes: ["Medical Condition", "Psychiatric Condition", "E.R. Not Admitted", "Admitted"],
            aggressionTypes: ["Physical", "Verbal", "Sexual", "Financial/Property", "Injury (if yes, complete injury section)", "Charges filed or Police involvement (Complete unlawful/police section"],
            vehicleTypes: ["Public Transportation", "Provider Vehicle", "Private Vehicle", "State Vehicle"],
            medicalTypes: ["Adverse reaction (details below)", "Missed medical appointment (detials below)",
                "Missed Medication - Person refused medication", "Medical treatment provided (from injury section details below)", "Other (details below)"],
            medErrorTypes: ["Missed medication", "Wrong medication", "Wrong dose", "Wrong person", "Wrong time", "wrong route (oral, im, topical)", "Other"],
            behaviors: ["Assault", "Theft", "Sexual", "Property destruction/damage", "Personal property", "Property of other person", "Domestic Violence", "Disturbance", "Other"],
            victims: ["Family member", "Person served", "Staff member", "Unknown", "None", "Other"],
            deaths: ["Suicide", "Due to injury or illness (complete that section)", "Unknown"],
            actions: ["Pharmacist consultation", "Counseling", "HRC Review", "Nurse consultation", "Psychiatric consultation",
                "Denial of rights submitted", "Doctor consultation", "Functional assessment", "Emergency respite",
                "ER treatment", "PBS team formed", "Psychological consultation", "Adjustment to ISP", "Other"],
            titleForm: "New Incident",
            nvIncidentID: "",
            newRegionalCenter: "",
            newProgram: "",
            programs: [],
            newProgramType: "",
            newType: "",
            newDSINumber: "",
            newDateReceived: "",
            newDSORNumber: "",
            newIncidentType: "",
            newIncidentDate: "",
            newIncidentTime: "",
            newProvider: "Redhead Supports",
            newReportDate: "",
            newServiceCoordinator: "",
            newPrimaryPerson: "",
            newInvolvedWitness: "",
            newPersonServed: "",
            newStaff: "",
            newOther: "",
            newPerson2: "",
            newPersonName2: "",
            newInvolvedWitness2: "",
            newPersonServed2: "",
            newStaff2: "",
            newOther2: "",
            newPerson3: "",
            newPersonName3: "",
            newInvolvedWitness3: "",
            newPersonServed3: "",
            newStaff3: "",
            newOther3: "",
            newPerson4: "",
            newPersonName4: "",
            newInvolvedWitness4: "",
            newPersonServed4: "",
            newStaff4: "",
            newOther4: "",
            newPerson5: "",
            newPersonName5: "",
            newInvolvedWitness5: "",
            newPersonServed5: "",
            newStaff5: "",
            newOther5: "",
            newPerson6: "",
            newPersonName6: "",
            newInvolvedWitness6: "",
            newPersonServed6: "",
            newStaff6: "",
            newOther6: "",
            newLiving: [],
            newJDT: "",
            newEventDescription: "",
            newMissingPersonReport: "",
            newInjury: "",
            newInjuryType: "",
            newInjuryDetails: "",
            newInjuryCause: "",
            newInjuryDetails2: "",
            newInjuryPerson: "",
            newInjuryDetails3: "",
            newNurse: "",
            newMedicalTreatment: "",
            newUnplanned: "",
            newHospitalType: [],
            newAggression: "",
            newAggressionType: [],
            newAbuseNeglect: "",
            newAbuseDescription: "",
            newVehicleAccident: "",
            newVehicleType: [],
            newMedical: "",
            newMedicalType: "",
            newMedicalDetails: "",
            newMedError: "",
            newMedErrorType: [],
            newMedOther: "",
            newErrorDate: "",
            newErrorTime: "",
            newPhysicianNotified: "",
            newEffects: "",
            newNursingDetails: "",
            newStaffName: "",
            newMedDate: "",
            newSignatureDate: "",
            newMedDateTime: "",
            newBehavior: [],
            newPropertyDamage: "",
            newDamageOther: "",
            newPolice: "",
            newPoliceInvolved: "",
            newArrested: "",
            newDamage: "",
            newVictim: "",
            newVictimOther: "",
            newDeath: "",
            newDeathType: "",
            newOtherDescribe: "",
            newASDS: "",
            newFamily: "",
            newGuardian: "",
            newServiceCoordinatorName: "",
            newPolice911: "",
            newHealthCareQuality: "",
            newAgingServices: "",
            newCPS: "",
            newCoroner: "",
            newShiftSupervisor: "",
            newNurseName: "",
            newAgencyAdmin: "",
            newAgencyOther: "",
            newActionsTaken: "",
            newReportersName: "",
            newReportersSignature: "",
            reportersSignature: false,
            newReportersTitle: "",
            newReportersDate: "",
            newSupervisorSignature: "",
            newSupervisorTitle: "",
            newSupervisorDate: "",
            newGuardianNotified: "",
            newGuardianDate: "",
            newSCNotified: "",
            newSCDate: "",
            newCompliance: "",
            newComplianceDate: "",
            newComplianceSignature: "",
            newWellSkyIR: "",
            newStaffSignature: "",
            person2: false,
            person3: false,
            staffSignature: false,
            supervisorSignature: false,
            managerSignature: false,
            reviewedSignature: false,
            calendarMenu: false,
            calendar2Menu: false,
            calendar3Menu: false,
            calendar4Menu: false,
            calendar5Menu: false,
            calendar6Menu: false,
            calendar7Menu: false,
            calendar8Menu: false,
            calendar9Menu: false,
            calendar10Menu: false,
            calendarMenu10: false,
            calendarMenu11: false,
            calendarMenu12: false,
            calendarMenu13: false,
            calendarMenu14: false,
            calendarMenu15: false,
            calendarMenu16: false,
            calendarMenu17: false,
            calendarMenu18: false,
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            userState: localStorage.getItem('userState'),
            editedIndex: -1,
            requiredField: [
                v => !!v || 'This is required',
            ],
            readonly: false,
            newNotificationSubmitted: '',
            newReportSubmitted: '',
            newOLReportDate: "",
            reportSubmittedDate: "",
            isUpdatingIncident: false,
            isLoading: true,
            newJDTOther: '',
            newDocument: [],
            selectedIncidentReport: null,
            downloadUrl: '',
            uploadFiles: null
        };
    },

    computed: {
        clientName() {
            // `this` points to the component instance
            return this.$store.state.clients.client.Name;
        }
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    mounted() {
        if (!this.newIncident) {
            this.getIncident();
        }

        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.id, this.token, 'NVIncidentReport');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.id, this.token, 'NVIncidentReport');
        });
    },

    created() {
        this.newIncident = this.$route.query.newIncident === 'true';

        this.getUsers();
        this.getPrograms();
        let nevadaIncidentId = this.$route.query.view;

        if (nevadaIncidentId) {
            NevadaIncidentService.getById(nevadaIncidentId).then((response) => {
                this.viewIncident(response.data.incident);
            })
        }

        if (this.selectedIncidentReport && this.selectedIncidentReport.Documents && this.selectedIncidentReport.Documents.length) {
            this.newDocument = this.selectedIncidentReport.Documents.map(url => {
                return {
                    url: url,
                    type: this.getFileType(url)
                };
            });
        }

    },

    methods: {
        initialize() {
            this.incidents = [];
        },

        validate() {
            return this.$refs.form.validate();
        },

        validateReset() {
            if (this.$refs.form !== undefined) {
                this.$refs.form.reset();
            }
        },

        getPrograms() {
            axios.get(`${url}/units/state/${this.userState}`).then(async res => {
                this.programs = res.data.units;

            });
        },

        joinDocument() {
            if (this.newDocument.length > 0) {
                return this.newDocument.map(file => file.name).join(', ');
            } else {
                return '';
            }
        },

        downloadDocument(url) {
            if (url) {
                window.open(url, '_blank');
            } else {
                alert('No documents available');
            }
        },

        removeImage(index) {
            const nvIncidentID = this.selectedIncidentReport._id;

            axios.delete(`${url}/nevadaIncidents/${nvIncidentID}/document/${index}`)
                .then(() => {
                    this.selectedIncidentReport.Documents.splice(index, 1);
                })
                .catch((error) => {
                    console.error(error);
                });
        },

        clearFieldsAndBack() {
            this.clearFields();

            if (this.$route.query.clientNav === 'false') {
                this.$router.go(-1);
            } else {
                this.$router.push({
                    path: `/nvIncidents/${this.clientID}`
                });
            }
        },

        getUnits: function () {
            axios.get(`${url}/units`).then(async res => {
                res.data.units.forEach(item => {
                    this.units.push(item.Name)
                })
            });
        },

        getCodes: function () {
            axios.get(`${url}/codes`).then(async res => {
                this.codes = res.data.codes;
            });
        },

        getIncident() {
            axios.get(`${url}/nevadaIncidents/${this.id}`).then(response => {
                this.incident = response.data.incident;
                this.viewIncident(this.incident);
            }).catch(error => {
                console.error('Error fetching incidents:', error);
            });
        },

        async addIncident() {
            if (this.validate()) {
                const payload = {
                    RegionalCenter: this.newRegionalCenter,
                    Program: this.newProgram,
                    ProgramType: this.newProgramType,
                    Type: this.newType,
                    DSINumber: this.newDSINumber,
                    DateReceived: this.newDateReceived,
                    DSORNumber: this.newDSORNumber,
                    IncidentType: this.newIncidentType,
                    IncidentDate: this.newIncidentDate,
                    IncidentTime: this.newIncidentTime,
                    Provider: this.newProvider,
                    ReportDate: this.newReportDate,
                    ServiceCoordinator: this.newServiceCoordinator,
                    PrimaryPerson: this.newPrimaryPerson,
                    InvolvedWitness: this.newInvolvedWitness,
                    PersonServed: this.newPersonServed,
                    Staff: this.newStaff,
                    Other: this.newOther,
                    Person2: this.newPerson2,
                    PersonName2: this.newPersonName2,
                    InvolvedWitness2: this.newInvolvedWitness2,
                    PersonServed2: this.newPersonServed2,
                    Staff2: this.newStaff2,
                    Other2: this.newOther2,
                    Person3: this.newPerson3,
                    PersonName3: this.newPersonName3,
                    InvolvedWitness3: this.newInvolvedWitness3,
                    PersonServed3: this.newPersonServed3,
                    Staff3: this.newStaff3,
                    Other3: this.newOther3,
                    Person4: this.newPerson4,
                    PersonName4: this.newPersonName4,
                    InvolvedWitness4: this.newInvolvedWitness4,
                    PersonServed4: this.newPersonServed4,
                    Staff4: this.newStaff4,
                    Other4: this.newOther4,
                    Person5: this.newPerson5,
                    PersonName5: this.newPersonName5,
                    InvolvedWitness5: this.newInolvedWitness5,
                    PersonServed5: this.newPersonServed5,
                    Staff5: this.newStaff5,
                    Other5: this.newOther5,
                    Person6: this.newPerson6,
                    PersonName6: this.PersonName6,
                    InvolvedWitness6: this.newInvolvedWitness6,
                    PersonServed6: this.newPersonServed6,
                    Staff6: this.newStaff6,
                    Other6: this.newOther6,
                    Living: this.newLiving,
                    JDT: this.newJDT,
                    JDTOther: this.newJDTOther,
                    EventDescription: this.newEventDescription,
                    MissingPersonReport: this.newMissingPersonReport,
                    Injury: this.newInjury,
                    InjuryType: this.newInjuryType,
                    InjuryDetails: this.newInjuryDetails,
                    InjuryCause: this.newInjuryCause,
                    InjuryDetails2: this.newInjuryDetails2,
                    InjuryPerson: this.newInjuryPerson,
                    InjuryDetails3: this.newInjuryDetails3,
                    Nurse: this.newNurse,
                    MedicalTreatment: this.newMedicalTreatment,
                    Unplanned: this.newUnplanned,
                    HospitalType: this.newHospitalType,
                    Aggression: this.newAggression,
                    AggressionType: this.newAggressionType,
                    AbuseNeglect: this.newAbuseNeglect,
                    AbuseDescription: this.newAbuseDescription,
                    VehicleAccident: this.newVehicleAccident,
                    VehicleType: this.newVehicleType,
                    Medical: this.newMedical,
                    MedicalType: this.newMedicalType,
                    MedicalDetails: this.newMedicalDetails,
                    MedError: this.newMedError,
                    MedErrorType: this.newMedErrorType,
                    MedOther: this.newMedOther,
                    ErrorDate: this.newErrorDate,
                    ErrorTime: this.newErrorTime,
                    PhysicianNotified: this.newPhysicianNotified,
                    Effects: this.newEffects,
                    NursingDetails: this.newNursingDetails,
                    StaffName: this.newStaffName,
                    MedDate: this.newMedDate,
                    SignatureDate: this.newSignatureDate,
                    MedDateTime: this.newMedDateTime,
                    Behavior: this.newBehavior,
                    PropertyDamage: this.newPropertyDamage,
                    DamageOther: this.newDamageOther,
                    PoliceInvolved: this.newPoliceInvolved,
                    Police: this.newPolice,
                    Arrested: this.newArrested,
                    Damage: this.newDamage,
                    Victim: this.newVictim,
                    VictimOther: this.newVictimOther,
                    Death: this.newDeath,
                    DeathType: this.newDeathType,
                    OtherDescribe: this.newOtherDescribe,
                    ASDS: this.newASDS,
                    Family: this.newFamily,
                    Guardian: this.newGuardian,
                    ServiceCoordinatorName: this.newServiceCoordinatorName,
                    Police911: this.newPolice911,
                    HealthCareQuality: this.newHealthCareQuality,
                    AgingServices: this.newAgingServices,
                    CPS: this.newCPS,
                    Coroner: this.newCoroner,
                    ShiftSupervisor: this.newShiftSupervisor,
                    NurseName: this.newNurseName,
                    AgencyAdmin: this.newAgencyAdmin,
                    AgencyOther: this.newAgencyOther,
                    ActionsTaken: this.newActionsTaken,
                    ReportersName: this.newReportersName,
                    ReportersSignature: this.newReportersSignature,
                    ReportersTitle: this.newReportersTitle,
                    ReportersDate: this.newReportersDate,
                    SupervisorSignature: this.newSupervisorSignature,
                    SupervisorTitle: this.newSupervisorTitle,
                    SupervisorDate: this.newSupervisorDate,
                    GuardianNotified: this.newGuardianNotified,
                    GuardianDate: this.newGuardianDate,
                    SCNotified: this.newSCNotified,
                    SCDate: this.newSCDate,
                    Compliance: this.newCompliance,
                    ComplianceDate: this.newComplianceDate,
                    ComplianceSignature: this.newComplianceSignature,
                    WellSkyIR: this.newWellSkyIR,
                    NotificationSubmitted: this.newNotificationSubmitted,
                    ReportSubmitted: this.newReportSubmitted,
                    ReportSubmittedDate: this.reportSubmittedDate,
                    ClientID: this.clientID,
                    OLReportDate: this.newOLReportDate,
                    StaffSignature: this.newStaffSignature,
                    StaffSigned: this.staffSignature,
                };

                const addNevadaIncidentUrl = `${url}/nevadaIncidents`;

                this.showLoadingAddDialog();

                axios.post(addNevadaIncidentUrl, payload)
                    .then(async (response) => {
                        this.nvIncidentID = response.data._id;

                        if (this.uploadFiles !== null && this.uploadFiles !== undefined) {
                            // Close the initial loading dialog and show the attachment upload dialog
                            Swal.close();
                            this.showUploadingAttachmentsDialog();
                            await this.uploadIncidentDocuments();
                        }
                        this.showSuccessAddDialog();
                    })
                    .catch(error => {
                        console.error(error);

                        this.showErrorDialog();
                    })
                    .finally(() => {
                        Swal.close();
                    });
            }
        },

        async updateIncident() {
            if (this.validate()) {
                const payload = {
                    RegionalCenter: this.newRegionalCenter,
                    Program: this.newProgram,
                    ProgramType: this.newProgramType,
                    Type: this.newType,
                    DSINumber: this.newDSINumber,
                    DateReceived: this.newDateReceived,
                    DSORNumber: this.newDSORNumber,
                    IncidentType: this.newIncidentType,
                    IncidentDate: this.newIncidentDate,
                    IncidentTime: this.newIncidentTime,
                    Provider: this.newProvider,
                    ReportDate: this.newReportDate,
                    ServiceCoordinator: this.newServiceCoordinator,
                    PrimaryPerson: this.newPrimaryPerson,
                    InvolvedWitness: this.newInvolvedWitness,
                    PersonServed: this.newPersonServed,
                    Staff: this.newStaff,
                    Other: this.newOther,
                    Person2: this.newPerson2,
                    PersonName2: this.newPersonName2,
                    InvolvedWitness2: this.newInvolvedWitness2,
                    PersonServed2: this.newPersonServed2,
                    Staff2: this.newStaff2,
                    Other2: this.newOther2,
                    Person3: this.newPerson3,
                    PersonName3: this.newPersonName3,
                    InvolvedWitness3: this.newInvolvedWitness3,
                    PersonServed3: this.newPersonServed3,
                    Staff3: this.newStaff3,
                    Other3: this.newOther3,
                    Person4: this.newPerson4,
                    PersonName4: this.newPersonName4,
                    InvolvedWitness4: this.newInvolvedWitness4,
                    PersonServed4: this.newPersonServed4,
                    Staff4: this.newStaff4,
                    Other4: this.newOther4,
                    Person5: this.newPerson5,
                    PersonName5: this.newPersonName5,
                    InvolvedWitness5: this.newInolvedWitness5,
                    PersonServed5: this.newPersonServed5,
                    Staff5: this.newStaff5,
                    Other5: this.newOther5,
                    Person6: this.newPerson6,
                    PersonName6: this.PersonName6,
                    InvolvedWitness6: this.newInvolvedWitness6,
                    PersonServed6: this.newPersonServed6,
                    Staff6: this.newStaff6,
                    Other6: this.newOther6,
                    Living: this.newLiving,
                    JDT: this.newJDT,
                    EventDescription: this.newEventDescription,
                    MissingPersonReport: this.newMissingPersonReport,
                    Injury: this.newInjury,
                    InjuryType: this.newInjuryType,
                    InjuryDetails: this.newInjuryDetails,
                    InjuryCause: this.newInjuryCause,
                    InjuryDetails2: this.newInjuryDetails2,
                    InjuryPerson: this.newInjuryPerson,
                    InjuryDetails3: this.newInjuryDetails3,
                    Nurse: this.newNurse,
                    MedicalTreatment: this.newMedicalTreatment,
                    Unplanned: this.newUnplanned,
                    HospitalType: this.newHospitalType,
                    Aggression: this.newAggression,
                    AggressionType: this.newAggressionType,
                    AbuseNeglect: this.newAbuseNeglect,
                    AbuseDescription: this.newAbuseDescription,
                    VehicleAccident: this.newVehicleAccident,
                    VehicleType: this.newVehicleType,
                    Medical: this.newMedical,
                    MedicalDetails: this.newMedicalDetails,
                    MedError: this.newMedError,
                    MedErrorType: this.newMedErrorType,
                    MedOther: this.newMedOther,
                    ErrorDate: this.newErrorDate,
                    ErrorTime: this.newErrorTime,
                    PhysicianNotified: this.newPhysicianNotified,
                    Effects: this.newEffects,
                    NursingDetails: this.newNursingDetails,
                    StaffName: this.newStaffName,
                    MedDate: this.newMedDate,
                    SignatureDate: this.newSignatureDate,
                    MedDateTime: this.newMedDateTime,
                    Behavior: this.newBehavior,
                    PropertyDamage: this.newPropertyDamage,
                    DamageOther: this.newDamageOther,
                    Police: this.newPolice,
                    PoliceInvolved: this.newPoliceInvolved,
                    Arrested: this.newArrested,
                    Damage: this.newDamage,
                    Victim: this.newVictim,
                    VictimOther: this.newVicitmOther,
                    Death: this.newDeath,
                    DeathType: this.newDeathType,
                    OtherDescribe: this.newOtherDescribe,
                    ASDS: this.newASDS,
                    Family: this.newFamily,
                    Guardian: this.newGuardian,
                    ServiceCoordinatorName: this.newServiceCoordinatorName,
                    Police911: this.newPolice911,
                    HealthCareQuality: this.newHealthCareQuality,
                    AgingServices: this.newAgingServices,
                    CPS: this.newCPS,
                    Coroner: this.newCoroner,
                    ShiftSupervisor: this.newShiftSupervisor,
                    NurseName: this.newNurseName,
                    AgencyAdmin: this.newAgencyAdmin,
                    AgencyOther: this.newAgencyOther,
                    ActionsTaken: this.newActionsTaken,
                    ReportersName: this.newReportersName,
                    ReportersSignature: this.newReportersSignature,
                    ReportersTitle: this.newReportersTitle,
                    ReportersDate: this.newReportersDate,
                    SupervisorSignature: this.newSupervisorSignature,
                    SupervisorTitle: this.newSupervisorTitle,
                    SupervisorDate: this.newSupervisorDate,
                    GuardianNotified: this.newGuardianNotified,
                    GuardianDate: this.newGuardianDate,
                    SCNotified: this.newSCNotified,
                    SCDate: this.newSCDate,
                    Compliance: this.newCompliance,
                    ComplianceDate: this.newComplianceDate,
                    Documents: this.newDocument,
                    ComplianceSignature: this.newComplianceSignature,
                    WellSkyIR: this.newWellSkyIR,
                    MedicalType: this.newMedicalType,
                    JDTOther: this.newJDTOther,
                    NotificationSubmitted: this.newNotificationSubmitted,
                    ReportSubmitted: this.newReportSubmitted,
                    ReportSubmittedDate: this.reportSubmittedDate,
                    OLReportDate: this.newOLReportDate,
                    StaffSignature: this.newStaffSignature,
                    StaffSigned: this.staffSignature,
                };

                const updateNvIncidentUrl = `${url}/nevadaIncidents/${this.nvIncidentID}`;
                this.showLoadingUpdateDialog();

                try {
                    await axios.put(updateNvIncidentUrl, payload);

                    if (this.uploadFiles !== null && this.uploadFiles !== undefined) {
                        await this.uploadIncidentDocuments();
                    }

                    this.showSuccessUpdateDialog();
                    this.clearFieldsAndBack();
                } catch (error) {
                    console.error(error);
                    this.showErrorDialog();
                }
            }
        },

        viewIncident(item) {
            //these lines of code is to change any past "true" or "false" in db
            //to "Yes" or "No" to avoid yes and no being selected
            this.titleForm = "Viewing Incident";
            this.selectedIncidentReport = item;
            this.nvIncidentID = item._id;
            this.newRegionalCenter = item.RegionalCenter;
            this.newProgram = item.Program;
            this.newProgramType = item.ProgramType;
            this.newType = item.Type;
            this.newDSINumber = item.DSINumber;
            this.newDateReceived = item.DateReceived;
            this.newDSORNumber = item.DSORNumber;
            this.newIncidentType = item.IncidentType;
            this.newIncidentDate = item.IncidentDate;

            if (!item.IncidentTime) {
                this.newIncidentTime = '';
            } else {
                this.newIncidentTime = new Date(item.IncidentTime);
            }

            this.newProvider = item.Provider;
            this.newReportDate = item.ReportDate;
            this.newServiceCoordinator = item.ServiceCoordinator;
            this.newPrimaryPerson = item.PrimaryPerson;
            this.newInvolvedWitness = item.InvolvedWitness;
            this.newPersonServed = item.PersonServed === 'true';
            this.newStaff = item.Staff === 'true';
            this.newOther = item.Other === 'true';
            this.newPerson2 = item.Person2;
            this.newPersonName2 = item.PersonName2;
            this.newInvolvedWitness2 = item.InvolvedWitness2;
            this.newPersonServed2 = item.PersonServed2 === 'true';
            this.newStaff2 = item.Staff2 === 'true';
            this.newOther2 = item.Other2 === 'true';
            this.newPerson3 = item.Person3;
            this.newPersonName3 = item.PersonName3;
            this.newInvolvedWitness3 = item.InvolvedWitness3;
            this.newPersonServed3 = item.PersonServed3 === 'true';
            this.newStaff3 = item.Staff3 === 'true';
            this.newOther3 = item.Other3 === 'true';
            this.newPerson4 = item.Person4;
            this.newPersonName4 = item.PersonName4;
            this.newInvolvedWitness4 = item.InvolvedWitness4;
            this.newPersonServed4 = item.PersonServed4 === 'true';
            this.newStaff4 = item.Staff4 === 'true';
            this.newOther4 = item.Other4 === 'true';
            this.newPerson5 = item.Person5;
            this.newPersonName5 = item.PersonName5;
            this.newInvolvedWitness5 = item.InvolvedWitness5;
            this.newPersonServed5 = item.PersonServed5 === 'true';
            this.newStaff5 = item.Staff5 === 'true';
            this.newOther5 = item.Other5 === 'true';
            this.newPerson6 = item.Person6;
            this.newPersonName6 = item.PersonName6;
            this.newInvolvedWitness6 = item.InvolvedWitness6;
            this.newPersonServed6 = item.PersonServed6 === 'true';
            this.newStaff6 = item.Staff6 === 'true';
            this.newOther6 = item.Other6 === 'true';
            this.newLiving = item.Living;
            this.newJDT = AppUtil.stripInvalidValue(item.JDT, 'string');
            this.newEventDescription = item.EventDescription;
            this.newMissingPersonReport = item.MissingPersonReport;
            this.newInjury = item.Injury;
            this.newInjuryType = item.InjuryType;
            this.newInjuryDetails = item.InjuryDetails;
            this.newInjuryCause = item.InjuryCause;
            this.newInjuryDetails2 = item.InjuryDetails2;
            this.newInjuryPerson = item.InjuryPerson;
            this.newInjuryDetails3 = item.InjuryDetails3;
            // this.newNurse = item.Nurse;
            if (item.Nurse === 'true') {
                this.newNurse = 'Yes'
            } else if (item.Nurse === 'false') {
                this.newNurse = 'No'
            } else {
                this.newNurse = item.Nurse
            }
            // this.newMedicalTreatment = item.MedicalTreatment;
            if (item.MedicalTreatment === 'true') {
                this.newMedicalTreatment = 'Yes'
            } else if (item.MedicalTreatment === 'false') {
                this.newMedicalTreatment = 'No'
            } else {
                this.newMedicalTreatment = item.MedicalTreatment
            }
            this.newUnplanned = AppUtil.stripInvalidValue(item.Unplanned, 'string');
            this.newHospitalType = item.HospitalType;
            this.newAggression = item.Aggression;
            this.newAggressionType = item.AggressionType;
            this.newAbuseNeglect = item.AbuseNeglect;
            this.newAbuseDescription = item.AbuseDescription;
            this.newVehicleAccident = item.VehicleAccident;
            this.newVehicleType = item.VehicleType;
            this.newMedical = item.Medical;
            this.newMedicalDetails = item.MedicalDetails;
            this.newMedError = item.MedError;
            this.newMedErrorType = item.MedErrorType;
            this.newMedOther = item.MedOther;
            this.newErrorDate = item.ErrorDate;
            this.newErrorTime = item.ErrorTime;
            this.newPhysicianNotified = item.PhysicianNotified === 'true';
            this.newEffects = item.Effects;
            this.newNursingDetails = item.NursingDetails;
            this.newStaffName = item.StaffName;
            this.newMedDate = item.MedDate;
            this.newSignatureDate = item.SignatureDate;
            this.newMedDateTime = item.MedDateTime;
            this.newBehavior = item.Behavior;
            this.newPropertyDamage = item.PropertyDamage;
            this.newDamageOther = item.DamageOther;
            this.newPolice = item.Police;
            this.newPoliceInvolved = item.PoliceInvolved;
            this.newArrested = item.Arrested;
            this.newDamage = item.Damage;
            this.newVictim = item.Victim;
            this.newVictimOther = item.VictimOther;
            this.newDeath = item.Death;
            this.newDeathType = item.DeathType;
            this.newOtherDescribe = item.OtherDescribe;
            this.newASDS = item.ASDS;
            this.newFamily = item.Family;
            this.newGuardian = item.Guardian;
            this.newServiceCoordinatorName = item.ServiceCoordinatorName;
            this.newPolice911 = item.Police911;
            this.newHealthCareQuality = item.HealthCareQuality;
            this.newAgingServices = item.AgingServices;
            this.newCPS = item.CPS;
            this.newCoroner = item.Coroner;
            this.newShiftSupervisor = item.ShiftSupervisor;
            this.newNurseName = item.NurseName;
            this.newAgencyAdmin = item.AgencyAdmin;
            this.newAgencyOther = item.AgencyOther;
            this.newActionsTaken = AppUtil.stripInvalidValue(item.ActionsTaken, 'string');
            this.newReportersName = item.ReportersName;
            this.newReportersSignature = item.ReportersSignature;
            this.newReportersTitle = item.ReportersTitle;
            this.newReportersDate = item.ReportersDate;
            this.newSupervisorSignature = item.SupervisorSignature;
            this.newSupervisorTitle = item.SupervisorTitle;
            this.newSupervisorDate = item.SupervisorDate;
            this.newGuardianNotified = item.GuardianNotified === 'true';
            this.newGuardianDate = moment(item.GuardianDate).format("YYYY-MM-DD HH:mm");
            this.newSCNotified = item.SCNotified === 'true';
            this.newSCDate = moment(item.SCDate).format("YYYY-MM-DD HH:mm");
            this.newCompliance = item.Compliance;
            this.newComplianceDate = moment(item.ComplianceDate).format("YYYY-MM-DD HH:mm");
            // this.newComplianceDate = moment(item.ComplianceDate).format("YYYY-MM-DD HH:mm");
            this.newComplianceSignature = item.ComplianceSignature;
            this.newWellSkyIR = item.WellSkyIR;
            this.newMedicalType = item.MedicalType;
            this.newJDTOther = item.JDTOther;
            this.newNotificationSubmitted = item.NotificationSubmitted;
            this.newReportSubmitted = item.ReportSubmitted;
            this.reportSubmittedDate = moment(item.ReportSubmittedDate).format("YYYY-MM-DD HH:mm");
            this.newOLReportDate = moment(item.OLReportDate).format("YYYY-MM-DD HH:mm");
            this.newStaffSignature = item.StaffSignature;
            this.staffSignature = item.StaffSigned;
            this.newDocument = item.Documents;
        },

        getUsers() {
            axios.get(`${url}/users`).then(async res => {
                this.users = res.data.users;
                for (let i = 0; i < this.users.length; i++) {
                    if (this.userID === this.users[i]._id) {
                        this.staff = this.users[i].Name
                    }
                }
            });
        },

        addSignature() {

            if (this.newSupervisorSignature === "") {
                this.supervisorSignature = true;
                this.newSupervisorSignature = this.staff + " - " + new Date();
            } else {
                this.newSupervisorSignature = ""
                this.supervisorSignature = false;
            }
        },

        addStaffSignature() {
            if (this.newStaffSignature === "") {
                this.staffSignature = true;
                this.newStaffSignature = this.staff + " - " + new Date();
            } else {
                this.newStaffSignature = ""
                this.staffSignature = false;
            }
        },

        addReportersSignature() {
            this.newReportersSignature = this.staff + " - " + new Date();


        },

        addSupervisorSignature() {
            this.newSupervisorSignature = this.staff + " - " + new Date();
        },

        addManagerSignature() {
            if (this.newManagerSignature === "") {
                this.managerSignature = true;
                this.newManagerSignature = this.staff + " - " + new Date();
            } else {
                this.newManagerSignature = ""
                this.managerSignature = false;
            }
        },

        addReviewedSignature() {
            if (this.newReviewedSignature === "") {
                this.reviewedSignature = true;
                this.newReviewedSignature = this.staff + " - " + new Date();
            } else {
                this.newReviewedSignature = "";
                this.reviewedSignature = false;
            }
        },

        async fileSelected(e) {
            const files = [];

            const fileList = e.target ? e.target.files : e;

            for (let i = 0; i < fileList.length; i++) {
                const renamedFile = await this.renameFileHelper(fileList[i], this.clientName, "NevadaIncidentReport");
                files.push(renamedFile);
            }

            this.uploadFiles = files;
        },

        async uploadIncidentDocuments() {
            try {
                this.msg = true;
                this.text = 'Uploading incident documents';

                const formData = new FormData();

                for (let i = 0; i < this.uploadFiles.length; i++) {
                    formData.append('files', this.uploadFiles[i]);
                }

                const uploadUrl = `${url}/nevadaIncidents/fileUploader/${this.nvIncidentID}`;
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };

                await axios.post(uploadUrl, formData, config);
                this.getIncidents();

                this.msg = true;
                this.text = 'Incident documents successfully uploaded';
            } catch (e) {
                console.log({e});
            }
        },

        selectIncidentDocument(incidentDocument) {
            this.incidentDocument = incidentDocument;
        },

        clearFields() {
            this.$refs.form.reset();
            this.newDocument = [];
            this.selectedIncidentReport = null;
        },


        getFileType(url) {
            const extension = url.split('.').pop();
            return extension ? extension : 'unknown';
        },

        showLoadingAddDialog() {
            Swal.fire({
                html: 'Creating Incident, Please wait...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        },

        showUploadingAttachmentsDialog() {
            Swal.fire({
                title: 'Incident Created Successfully!',
                html: 'Now uploading attachments, please wait...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        },

        showLoadingUpdateDialog() {
            Swal.fire({
                html: 'Updating Incident, Please wait...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        },

        showSuccessAddDialog() {
            Swal.fire({
                icon: 'success',
                text: 'A new incident has been added successfully.',
                showConfirmButton: false,
                timer: 2000
            }).then(() => {
                this.clearFieldsAndBack();
            });
        },

        showSuccessUpdateDialog() {
            Swal.fire({
                icon: 'success',
                text: 'An incident has been updated successfully.',
                showConfirmButton: false,
                timer: 3000
            });
        },

        showErrorDialog() {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while adding/updating an incident.',
                showConfirmButton: true,
                confirmButtonText: 'OK'
            });
        },

        async generateDownloadUrl() {
            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            return `${url}/nevadaIncidents/download?id=${this.id}&tz=${encodeURIComponent(userTimeZone)}`;
        },

        async showPrint() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.id, this.token, 'NVIncidentReport');
        },

    },

}
;
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

#printTable {
    display: none;
}

#printItem {
    display: none;
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #printTable {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;

    }

    #printItem {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;


    }

    .hideOnPrint {
        display: none;
        border: none;
    }

    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }


}
</style>
